var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-list',{staticClass:"removeTableHead",attrs:{"fields":_vm.fields,"loading":_vm.state.loading,"list":_vm.state.list,"table-h":_vm.tableH,"show-action-col":false,"row-key":"id","showPage":false,"page-size-change":_vm.pageSizeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }